import { forwardRef, type Ref, type SVGProps } from "react";
const IconMinusCircleOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M16 4A12 12 0 1 1 4 16 12 12 0 0 1 16 4m0-2a14 14 0 1 0 14 14A14 14 0 0 0 16 2" />
    <rect width={16} height={2} x={8} y={15} rx={1} />
  </svg>
);
const ForwardRef = forwardRef(IconMinusCircleOutlineSVG);
ForwardRef.displayName = "IconMinusCircleOutline";
export { ForwardRef as IconMinusCircleOutline };
